import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/storeHub";

export const drugEstimateStockOut = (searchObject) => axios.post(API_PATH + "/get-list-stock-out-drugs", searchObject);

export const drugsDistribution = (searchObject) => axios.post(API_PATH + "/stock-out-drugs-in-store", searchObject);

export const confirmStockOutFromEMR = (object) => axios.post(API_PATH + "/confirm-stock-out-from-emr", object);

//lay danh sach phieu linh thuoc tong hop
export const pagingSyntheticDrugReceipt = (object) => axios.post(API_PATH + "/paging-synthetic-drug-receipt", object);

//lay danh sach phieu linh thuoc cá nhân
export const pagingIndividualDrugReceipt = (object) => axios.post(API_PATH + "/paging-drug-receipt", object);


//tong hop phieu linh thuoc tu cac phieu yeu cau linh thuoc noi tru
export const exportSyntheticReceiptRequest = (object) => axios.post(API_PATH + "/export-synthetic-receipt-request", object);

//kiem tra phieu linh thuoc cua khoa phong hien tai
export const checkSummaryDepartmentReq = (depCode) => axios.get(API_PATH + "/check-summary-department-request/" + depCode);

//cap nhat tong hop phieu linh thuoc moi
export const updateSummaryDepartmentReq = (object) => axios.put(API_PATH + "/update-summary-department-request", object);

//cap nhat tong hop phieu linh thuoc moi
export const getById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

// tìm kiếm yêu cầu lĩnh thuốc
export const searchStoreRequest = (searchObject) =>
    axios.post(API_PATH + "/search-store-request", searchObject);
// danh sách thuốc chưa được tổng hợp
export const getListGroupReqItem = (searchObject) =>
    axios.post(API_PATH + "/get-list-group-req-item", searchObject);

export const pagingStoreDepartment = (dto) => {
    let { pageIndex, pageSize } = dto;
    const url = ConstantList.API_EN_POINT_STORE + `/department/${pageIndex}/${pageSize}`;
    return axios.get(url, dto);
}